import { Controller } from "@hotwired/stimulus"

// Ticks the current time in the practice's timezone. The initial value is
// rendered server-side (no-JS fallback); this keeps it live and correct
// across DST because Intl formats against the IANA zone, not the browser's.
export default class extends Controller {
  static targets = ["time", "meridiem"]
  static values = { timeZone: String }

  connect() {
    this.formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: this.timeZoneValue,
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    })
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  render() {
    const parts = this.formatter.formatToParts(new Date())
    const part = (type) => parts.find((p) => p.type === type)?.value || ""

    this.timeTarget.textContent = `${part("hour")}:${part("minute")}`
    this.meridiemTarget.textContent = part("dayPeriod")
  }
}
